"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var owa_feature_flags_1 = require("owa-feature-flags");
var mobx_react_1 = require("mobx-react");
var styles = require('./FeatureFlagsHeader.scss');
var FeatureFlagsHeader = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsHeader, _super);
    function FeatureFlagsHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsHeader.prototype.render = function () {
        return (React.createElement("div", { className: styles.container },
            React.createElement("span", { className: styles.resetButton },
                React.createElement("a", { title: "Resets all the features back to their default values", href: "#", onClick: owa_feature_flags_1.resetFeatureFlags }, "resetFlags"))));
    };
    FeatureFlagsHeader = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsHeader);
    return FeatureFlagsHeader;
}(React.Component));
exports.default = FeatureFlagsHeader;
//# sourceMappingURL=FeatureFlagsHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/FeatureFlags/FeatureFlagsHeader.js
// module id = 6199
// module chunks = 38